"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const serializeHeaders_1 = tslib_1.__importDefault(require("./serializeHeaders"));
const serializeRequest = (request) => ["headers", "method", "url"].reduce((obj, key) => {
    if (request[key] instanceof Headers) {
        return { ...obj, [key]: (0, serializeHeaders_1.default)(request[key]) };
    }
    return { ...obj, [key]: request[key] };
}, {});
exports.default = serializeRequest;
